import { ActionReference, GameObjectReference, GameState, MoveRefrence } from "@shared/types";
import { LitElement, TemplateResult, css, html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { getState, performAction, performMove } from "../services/routeService";

@customElement("game-canvas")
export class GameCanvas extends LitElement {
    public static styles = css`
        .game {
            height: 100%;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: auto auto 1fr auto;
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

        .text-cloud {
            margin: 1rem;
            color: #000;
            position: relative;
            background-color: #fff;
            border: 2px solid #000;
            border-radius: 10px;
            padding: 20px;
            max-width: fit-content;
            font-size: 1.2rem;
        }

        .gameboy {
            width: 55vw;
            height: 92vh;
            background-color: #8f8f8f;
            border: 5px solid #333333;
            border-radius: 10px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .gameboy .top-screen,
        .gameboy .down-screen {
            width: 30vw;
            height: 40vh;
            position: absolute;
            top: 2rem;
            border-radius: 10px;
            border: 5px solid #333333;
        }

        .gameboy .top-screen {
            left: 50%;
            transform: translateX(-50%);
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }

        .gameboy .top {
            width: 100%;
            height: 50%;
            border-radius: 10px 10px 0 0;
            display: flex;
        }

        .gameboy .top .screen {
            flex: 8;
            background-color: black;
            margin: 1rem;
            border-radius: 10px;
            border: 5px solid #333333;
            background-size: cover;
        }

        .gameboy .top .screen img {
            width: 100%;
            height: 100%;
            image-rendering: pixelated;
            object-fit: cover;
        }

        .gameboy .top .details {
            flex: 2;
            border-radius: 0 0 10px 10px;
            display: flex;
        }

        .gameboy .down {
            bottom: 1rem;
            width: 100%;
            height: 50%;
            border-radius: 0 0 10px 10px;
            display: flex;
        }

        .gameboy .down .button-container {
            flex: 2;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .gameboy .down .button-container .buttons {
            position: absolute;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 1rem;
        }

        .gameboy .down .button-container .buttons button {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: gray;
            color: white;
            font-size: 20px;
            font-weight: bold;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
            transition: transform 0.1s ease-in-out;
            margin: 5px;
        }

        .gameboy .down .button-container .buttons button:hover {
            background-color: #333;
        }

        .x-button {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 0.6rem;
        }

        .a-button {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 1rem;
        }

        .y-button {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 1rem;
        }

        .b-button {
            position: absolute;
            bottom: 0.6rem;
            left: 50%;
            transform: translateX(-50%);
        }

        .gameboy .down .screen {
            flex: 8;
            background-color: black;
            margin: 1rem;
            border-radius: 10px;
            border: 5px solid #333333;
            display: flex;
            flex-direction: column;
        }

        .gameboy .down .screen .text {
            flex: 8;
            overflow-y: auto;
            scroll-behavior: smooth;
        }

        .gameboy .down .screen .menu {
            flex: 3;
            background-color: #6b9f9b;
            padding-top: 0.5rem;
            margin: 0.3rem;
            border-radius: 0.5rem;
            display: flex;
            flex-direction: column;
        }

        .gameboy .down .screen .menu .actions {
            flex-direction: column;
            overflow: auto;
            max-width: 100vw;
        }

        .gameboy .down .screen .menu .items {
            flex-direction: column;
            overflow: auto;
            max-width: 100vw;
        }

        .gameboy .down .screen .menu .button {
            background-color: #365758;
            border: 1px solid #332c57;
            padding: 5px 5px;
            margin: 0 10px 10px 10px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            font-size: 1.2rem;
            display: inline-block;
        }

        .gameboy .down .screen .menu .button.active,
        .gameboy .down .screen .menu .button:hover {
            background-color: #25424f;
        }

        .health-bar {
            width: 95%;
            height: 1rem;
            border: 1px solid #000;
            background-color: #333;
            border-radius: 3px;
            overflow: hidden;
            margin: 0.5rem;
        }

        .health {
            height: 100%;
            background-color: #984937;
            transition: width 0.3s ease-in-out;
        }

        /* Add pixelation effect */
        .health-bar,
        .health {
            image-rendering: pixelated;
            image-rendering: -moz-crisp-edges;
            image-rendering: crisp-edges;
        }

        .room-title {
            font-size: 0.8rem;
            font-weight: bold;
            text-align: center;
        }

        .nintendo-ds-plus {
            width: 6rem;
            height: 6rem;
            position: relative;
        }

        .horizontal-line,
        .vertical-line {
            position: absolute;
            background-color: gray;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
        }

        .horizontal-line {
            width: 100%;
            height: 2rem;
            top: 35%;
            transform: translateY(-2px);
        }

        .vertical-line {
            height: 100%;
            width: 2rem;
            left: 38%;
            transform: translateX(-2px);
        }

        .divider {
            height: 0.5rem;
            background-color: #333;
        }
    `;

    private roomTitle?: string;
    private roomImages?: string[];
    private contentText?: string[];
    private actionButtons?: ActionReference[];
    private moveButtons?: MoveRefrence[];
    private gameObjectButtons?: GameObjectReference[];
    private fight?: boolean;

    private selectedActionButton?: ActionReference;
    private selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();

    public connectedCallback(): void {
        super.connectedCallback();

        void this.refreshState();
    }

    private async refreshState(): Promise<void> {
        const state: GameState = await getState();

        this.updateState(state);
    }

    private updateState(state: GameState): void {
        //Reset the component
        this.roomTitle = state.roomTitle;
        this.roomImages = state.roomImages;
        this.contentText = state.text;
        this.actionButtons = state.actions;
        this.moveButtons = state.moves;
        this.gameObjectButtons = state.objects;
        this.fight = state.fight;

        this.selectedActionButton = undefined;
        this.selectedGameObjectButtons.clear();

        this.requestUpdate();
    }

    private async handleClickMove(button: MoveRefrence): Promise<void> {
        const state: GameState = await performMove(button.alias, ["azazel-character"]);
        this.updateState(state);
    }

    private async handleClickAction(button: ActionReference): Promise<void> {
        if (button.needsObject) {
            this.selectedActionButton = button;
            this.selectedGameObjectButtons.clear();

            this.requestUpdate();
        } else {
            const state: any = await performAction(button.alias);

            if (state === undefined) {
                return;
            }

            this.updateState(state);
        }
    }

    private async handleClickObject(button: GameObjectReference): Promise<void> {
        if (!this.selectedActionButton) {
            return;
        }

        this.selectedGameObjectButtons.add(button);

        const state: GameState | undefined = await performAction(
            this.selectedActionButton.alias,
            [...this.selectedGameObjectButtons].map((e) => e.alias)
        );

        if (this.selectedGameObjectButtons.size >= 2) {
            this.selectedActionButton = undefined;
            this.selectedGameObjectButtons.clear();
        }

        this.requestUpdate();

        if (state === undefined) {
            return;
        }

        this.updateState(state);
    }

    protected render(): TemplateResult {
        if (!localStorage.getItem("health") && this.fight) {
            localStorage.setItem("health", "100");
        }
        const health: number =
            Math.max(0, Math.min((Number(localStorage.getItem("health")) || 0) / 100, 1)) * 100;
        return html`
            <div class="gameboy">
                <div class="top">
                    <div class="details"></div>
                    <div class="screen" id="screen-image">
                        <img src="./assets/img/rooms/${this.roomImages?.[0]}.jpeg" alt="Azazel" />
                    </div>
                    <div class="details"></div>
                </div>
                <div class="divider"></div>
                <div class="down">
                    <div class="button-container">
                    <div class="nintendo-ds-plus">
                    <div class="horizontal-line"></div>
                    <div class="vertical-line"></div>
                  </div>                  
                    </div>
                    <div class="screen">
                        <div class="text">
                        <p class="room-title">${this.roomTitle}</p>
                        ${
                            this.fight
                                ? html`<div class="health-bar">
                                      <div class="health" style="width: ${health}%;"></div>
                                  </div>`
                                : nothing
                        }
                            ${this.contentText?.map((text) => html`<p class="text-cloud">${text}</p>`)}
                        </div>
                        <div class="menu">
                            <div class="actions">
                                ${
                                    !this.selectedActionButton && !this.fight
                                        ? this.actionButtons?.map(
                                              (button) => html`<a
                                                  class="button ${this.selectedActionButton === button
                                                      ? "active"
                                                      : ""}"
                                                  @click=${(): void => void this.handleClickAction(button)}
                                                  >${button.label}</a
                                              >`
                                          )
                                        : nothing
                                }
                            </div>
                            <div class="items">
                            ${
                                this.selectedActionButton && !this.fight
                                    ? html`<a
                                          class="button"
                                          @click=${(): void => {
                                              this.selectedActionButton = undefined;
                                              this.requestUpdate();
                                          }}
                                          ><-</a
                                      >`
                                    : nothing
                            }
                                ${
                                    this.selectedActionButton && !this.fight
                                        ? this.gameObjectButtons?.map(
                                              (button) => html`<a
                                                  class="button ${this.selectedGameObjectButtons.has(button)
                                                      ? "active"
                                                      : ""}"
                                                  @click=${(): void => void this.handleClickObject(button)}
                                                  >${button.name}</a
                                              >`
                                          )
                                        : nothing
                                }
                                ${
                                    this.fight
                                        ? this.moveButtons?.map(
                                              (button) => html`<a
                                                  class="button ${this.selectedActionButton === button
                                                      ? "active"
                                                      : ""}"
                                                  @click=${(): void => {
                                                      void this.handleClickMove(button);
                                                  }}
                                              >
                                                  ${button.label}</a
                                              >`
                                          )
                                        : nothing
                                }
                                    </div>
                            </div>
                        </div>
                        <div class="button-container">
                        <div class="buttons">
                            <button class="y-button">Y</button>
                            <button class="x-button">X</button>
                            <button class="b-button">B</button>
                            <button class="a-button">A</button>
                        </div></div>
                    </div>
                </div>
            </div>
        `;
    }
}
